import { type ComposeTarget } from "owa-mail-compose-store/lib/store/schema/ComposeTarget";
import { getActiveSxSId, isSxSDisplayed } from "owa-sxs-store";
import isDeepLink from "owa-url/lib/isDeepLink";
import { logUsage } from "owa-analytics";
import type { MailboxInfo } from "owa-client-types";

export default function getComposeTarget(mailboxInfo: MailboxInfo, targetWindow?: Window, isPopout?: boolean): ComposeTarget {
    const openInTab = !isDeepLink();
    const sxsId = getActiveSxSId(targetWindow || window);
    const openInSxS = isSxSDisplayed(sxsId);
    if (openInSxS) {
        logUsage("OpenComposeFromSxS", mailboxInfo);
    }
    if (!targetWindow || isPopout) {
        return isPopout
            ? 2 : openInTab
            ? 1 : 0;
    }
    
    if (openInSxS) {
        return 3;
    }
    
    if (!!targetWindow && targetWindow != window) {
        return 4;
    }
    else if (openInTab) {
        return 1;
    }
    
    return 0;
}
